module.exports = __webpack_public_path__ + "static/media/selected-white.b99aefab.svg";